import React from 'react'
import SIZE from '../../../global/Size'
import styled from 'styled-components';

const HorizontalMediaCard = ({ imageSrc1, title1, content1, imageSrc2, title2, content2 }) => {
  return (
    <OuterContainer>
      <Column>
        <StyledImage src={imageSrc1} alt={title1} />
        <Title>{title1}</Title>
        <Content>{content1}</Content>
      </Column>
      <Column>
        <StyledImage src={imageSrc2} alt={title2} />
        <Title>{title2}</Title>
        <Content>{content2}</Content>
      </Column>
    </OuterContainer>
  );
  }
  
  const OuterContainer = styled.div`
    width: 73%;
    height: auto;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    gap: 30px;

      /* 450px 이상 800px 미만 */
      @media (min-width: 450px) and (max-width: 799px) {
        flex-direction: column;
      }
      
      /* 450px 미만 */
      @media (max-width: 449px) {
        flex-direction: column;
      }
  `;
  
  const Column = styled.div`
    width: 50%;
    height: auto;
    display: flex;
    flex-direction: column;

      /* 450px 이상 800px 미만 */
      @media (min-width: 450px) and (max-width: 799px) {
        width: 100%;
      }
      
      /* 450px 미만 */
      @media (max-width: 449px) {
        width: 100%;
      }
  `;
  
  const StyledImage = styled.img`
    width: 98%;
    height: 100%;
    padding-bottom: 30px;
  `;
  
  const Title = styled.span`
    font-size: ${props => props.theme.SIZE.X0LARGE};
    font-weight: 600;
    padding-bottom: 20px;
  `;
  
  const Content = styled.span`
    line-height: 1.5;
  `;
  

export default HorizontalMediaCard